import { skipToken } from '@reduxjs/toolkit/query';
import Sidebar from '@rio-cloud/rio-uikit/Sidebar';
import Button from 'components/actions/Button';
import { SystemAdminDialogTypes, SystemAdminFormTypes } from 'helper/types';
import { useDispatch, useSelector } from 'react-redux';
import { useGetSystemFleetsAttributesQuery } from 'services/systemAdmin/fleets';
import {
    ActiveSidebar,
    clearActiveElements,
    getActiveSidebar,
    getSelectedFleet,
    setSelectedFleet,
    setSystemAdminOpenDialog,
} from 'store/slices/settingsPageSlice';
import { setFormFleetName, setSystemFleetsFormType } from 'store/slices/systemFleet';

import Can from '../../../components/auth/Can';
import SystemFleetsSidebarContent from './SystemFleetsSidebarContent';

interface FooterProps {
    onConfirm(): void;
}

const Footer = ({ onConfirm }: FooterProps) => (
    <Can type='fleets' action='edit'>
        <div className='Sidebar__footer SystemFleetsSidebar__footer'>
            <Button variant='outline' style='primary' className='Sidebar__button' onClick={onConfirm}>
                <span className='rioglyph rioglyph-pencil mr-5' />
                Edit
            </Button>
        </div>
    </Can>
);

const SystemFleetsSidebar = () => {
    const dispatch = useDispatch();
    const activeSidebar = useSelector(getActiveSidebar);
    const selectedFleet = useSelector(getSelectedFleet);

    const { isLoading, vehiclesList } = useGetSystemFleetsAttributesQuery(selectedFleet?.id ?? skipToken, {
        refetchOnMountOrArgChange: true,
        selectFromResult: state => {
            const attributes = state.data;
            return {
                ...state,
                vehiclesList: attributes?.vehicles.map(vehicle => vehicle.name),
            };
        },
    });

    const openEditFleetDialog = () => {
        dispatch(setSelectedFleet(selectedFleet));
        dispatch(setFormFleetName(selectedFleet?.name));
        dispatch(setSystemAdminOpenDialog(SystemAdminDialogTypes.FLEET_DIALOG));
        dispatch(setSystemFleetsFormType(SystemAdminFormTypes.EDIT_FORM));
    };

    const closeSidebar = () => {
        dispatch(clearActiveElements());
    };

    return (
        <Sidebar
            className='SystemFleetsSidebar__drawer'
            title={<p className='Sidebar__header'>Fleet detail</p>}
            titleClassName='pl-10'
            footer={<Footer onConfirm={openEditFleetDialog} />}
            closed={activeSidebar !== ActiveSidebar.FLEETS}
            onClose={closeSidebar}
            fly
        >
            <SystemFleetsSidebarContent fleet={selectedFleet} vehicles={vehiclesList} isLoading={isLoading} />
        </Sidebar>
    );
};

export default SystemFleetsSidebar;
